import { getListOfQueuesInfos } from '@/API/repositories/queue';
import { useRequestsContext } from '@/common/hooks/requestHook';
import { useEffect, useState } from 'react';

const useQueueList = () => {
	const { makeRequest, hasUnfilledRequest } = useRequestsContext();

	const [showActive, setShowActive] = useState(true);
	const [activeRaws, setActiveRaws] = useState([]);
	const [inActiveRaws, setInActiveRaws] = useState([]);
	const [showNew, setShowNew] = useState(false);
	const [showMigrateModal, setShowMigrateModal] = useState(false);
	const [selectedToDuplicate, setSelectedToDuplicate] = useState();

	const handleDuplicateClick = (_id) => {
		setSelectedToDuplicate(_id);
		setShowNew(true);
	};

	const getRows = (data, isActive) => {
		return data
			.filter((f) => !!f?.is_in_use === isActive)
			.sort((a, b) => a?.name.localeCompare(b?.name))
			.map((element) => {
				return {
					data: [element.name, element.users, element.contacts],
					_id: element._id,
				};
			});
	};

	const getQueueData = async () => {
		const response = await makeRequest(getListOfQueuesInfos);

		if (response.data) {
			setActiveRaws(getRows(response.data, true));
			setInActiveRaws(getRows(response.data, false));
		}
	};

	useEffect(() => {
		getQueueData();
	}, [showNew]);

	const isLoading = hasUnfilledRequest(getListOfQueuesInfos);

	return {
		isLoading,
		setShowNew,
		setShowMigrateModal,
		setShowActive,
		showActive,
		activeRaws,
		inActiveRaws,
		showNew,
		showMigrateModal,
		selectedToDuplicate,
		setSelectedToDuplicate,
		handleDuplicateClick,
	};
};

export default useQueueList;
